import { AudioPlayContext } from '@/contexts/AudioPlayContext';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { Dispatch, SetStateAction, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogContext } from '..';
import './index.scss';

type DialogHeaderProps = {
    title: string;
    dialogOpen?: Dispatch<SetStateAction<boolean>>;
};

export const DialogHeader = (props: DialogHeaderProps) => {
    const { dialogOpen, title } = props;
    const { t } = useTranslation();
    const { playButtonAudio } = useContext(AudioPlayContext);
    const { extraCloseHandler, resetCloseHandler } = useContext(DialogContext);

    return (
        <>
            <div className="dialog-header-container">
                <div id="place-hoder" className="dialog-header-place-holder" />
                <div className="dialog-header-title">{t(title)}</div>
                <IconButton
                    className="close-dialog-button"
                    onClick={() => {
                        if (dialogOpen) dialogOpen(false);
                        extraCloseHandler();
                        // reset
                        resetCloseHandler();
                        playButtonAudio();
                    }}
                >
                    <CloseIcon className="close-dialog-button-icon" />
                </IconButton>
            </div>
        </>
    );
};
